var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getAbiRingToken = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-ring.json")).default;
});
export const getAbiKtonToken = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-kton.json")).default;
});
export const getAbiLandResource = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-landResource.json")).default;
});
export const getAbiLandResourceV2 = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-landResourceV2.json")).default;
});
export const getAbiApostleAuction = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-apostleAuction.json")).default;
});
export const getAbiApostleClockAuctionV3 = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-apostleAuctionV3.json")).default;
});
export const getAbiApostleSiringV3 = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-apostleSiringV3.json")).default;
});
export const getAbiApostleBaseV3 = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-apostleBaseV3.json")).default;
});
export const getAbiTokenUseV2 = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-tokenUseV2.json")).default;
});
export const getAbiGoldRushRaffle = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-goldRushRaffle.json")).default;
});
export const getAbiClockAuctionV3 = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-clockAuctionV3.json")).default;
});
export const getAbiPveTeam = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-pveTeam.json")).default;
});
export const getAbiObjectOwnership = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-objectOwnership.json")).default;
});
export const getAbiSettingsRegistry = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-settingsRegistry.json")).default;
});
export const getAbiLottery = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-lottery.json")).default;
});
export const getAbiUserPoints = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-userPoints.json")).default;
});
export const getAbiFurnaceTreasure = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-furnaceTreasure.json")).default;
});
export const getAbiFurnaceItemBase = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-furnaceItemBase.json")).default;
});
export const getAbiFurnaceTakeback = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-furnaceTakeback.json")).default;
});
export const getAbiERC721 = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-erc721.json")).default;
});
export const getAbiERC721Collection = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-erc721collection.json")).default;
});
export const getAbiUniswapExchange = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    void chainId;
    return (yield import("../../config/abi/common/abi-uniswapExchange.json")).default;
});
